export var WHCM_SELECTED_ITEM_OUTLINE_WIDTH = 4;
export var WHCM_SELECTED_ITEM_OUTLINE_OFFSET = -4;
export var WHCM_FOCUSED_ITEM_BORDER_WIDTH = 2; //Windows system color for highlighted items in WHCM

export var WHCM_HIGHLIGHT_COLOR = 'highlight'; //Windows system color for general items in WHCM

export var WHCM_ITEM_COLOR = 'CanvasText';